module.exports = __webpack_public_path__ + "static/img/spinning-cogs.f0522e61.svg";